import { useSuspenseQuery } from "@tanstack/react-query";
import { pathPickBasketQueryApi } from "@/features/pathpick/features/basket/api/query";
import { PathPickFilterInfoResponse } from "@/features/pathpick/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 담은 상품 필터 정보 — 담은 상품에 실제로 있는 브랜드/카테고리만 내려온다.
// 전체 목록용(useGetPathPickFilterInfo)과 응답 스키마는 같지만 대상이 달라 캐시를 분리한다.
const useGetPathPickBasketFilterInfo = () => {
  const { companyId } = useCompanyIdentity();

  const { data: pathPickBasketFilterInfo } = useSuspenseQuery({
    queryKey: ["pathpick", "basket", "filter-info", companyId],
    queryFn: companyId
      ? () => pathPickBasketQueryApi.getPathPickBasketFilterInfo(companyId)
      : undefined,
    select: (data) => toCamelKeyObject(data) as PathPickFilterInfoResponse,
  });

  return { pathPickBasketFilterInfo };
};

export default useGetPathPickBasketFilterInfo;
